import { render, staticRenderFns } from "./VehicleTypeAdd.html?vue&type=template&id=798fddef&scoped=true&"
import script from "./VehicleTypeAdd.vue?vue&type=script&lang=js&"
export * from "./VehicleTypeAdd.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTypeAdd.vue?vue&type=style&index=0&id=798fddef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798fddef",
  null
  
)

export default component.exports